import { DriverList } from '@src/driver/domain/DriverList';
import { DriversClient } from '@src/driver/services/DriversClient';
import { useQuery } from '@tanstack/react-query';

export const useDrivers = (clientId: string) => {
  const { data: drivers = new DriverList([]), isLoading } =
    useQuery<DriverList>({
      queryKey: ['drivers.list', clientId],
      queryFn: () => DriversClient.list(clientId),
    });
  return {
    drivers,
    isLoading,
  };
};
